let eventHandlers = {};

function addAnalyticsEvents(eventName, callback) {
    if (eventHandlers[eventName] === undefined) {
        eventHandlers[eventName] = [];
    }

    eventHandlers[eventName] = [...eventHandlers[eventName], callback];

    return function unAddAnalyticsEvents() {
        eventHandlers[eventName] = eventHandlers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function sendAnalyticsEventData(eventName, data = []) {
    if (eventHandlers[eventName] && data != []) {
        eventHandlers[eventName].forEach((callback) => {
            if (typeof callback === 'function') callback(data);
        });
    }
}
